/* eslint-disable  @typescript-eslint/no-explicit-any */

import { useEffect, useRef } from 'react'

const usePrevious = (value: any, initialValue: any) => {
  const ref = useRef(initialValue)
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

/**
 * This is a debugging utility for the useEffect hook, it will log what dependecies
 * have cause the hook to trigger and a before and after comparison of the dependency value.
 * This is a development utility **DO NOT USE THIS IN PRODUCTION!**
 * @param effectHook the useEffect hook callback
 * @param dependencies the useEffect hook dependencies
 * @param depenencyNames the name of the dependices, if you use this you will see actual names in the logs, otherwise
 * you will see just index numbers
 * @param logName a unique name to help you find the log in the console
 */
export const useEffectDebugger = (
  effectHook: React.EffectCallback,
  dependencies: React.DependencyList,
  depenencyNames: string[] = [],
  logName?: string,
) => {
  const previousDeps = usePrevious(dependencies, [])
  const changedDeps = dependencies.reduce((accum, dependency, index) => {
    if (dependency !== previousDeps[index]) {
      const keyName = depenencyNames[index] || index
      return {
        ...(accum as any),
        [keyName]: {
          before: previousDeps[index],
          after: dependency,
        },
      }
    }
    return accum
  }, {})

  if (Object.keys(changedDeps as any).length) {
    // eslint-disable-next-line no-console
    console.log(`🪲 [use-effect-debugger] ${logName ? `- ${logName} ` : ``}`, changedDeps)
  }

  useEffect(effectHook, dependencies)
}
/* eslint-enable  @typescript-eslint/no-explicit-any */
